module.exports = __webpack_public_path__ + "media/images/products/category/6-6540ddc5c1ef5d2bb6cdaa427db41000.jpg";